module.exports = __webpack_public_path__ + "img/工厂同步.cd896d2f.svg";